import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@vwfs-bronson/bronson-react';
import { Container } from './Container';

export const StateToBeContacted = () => {
    const { t } = useTranslation('early-settlement');

    return (
        <Container title={t('dealer-callback.request-callback-section.to-be-contacted.title')}>
            <p className="u-mb-large">{t('dealer-callback.request-callback-section.to-be-contacted.text-line-1')}</p>

            <p className="u-mb-small">{t('dealer-callback.contact-us-section.text')}</p>
            <a href={t('dealer-callback.contact-us-section.link')}>
                <Button secondary id="contact-us-button" aria-label={t('dealer-callback.contact-us-section.button')}>
                    {t('dealer-callback.contact-us-section.button')}
                </Button>
            </a>
        </Container>
    );
};
